<div
  #dialogEl
  class="pd"
  role="dialog"
  aria-modal="true"
  aria-labelledby="pd-title"
  aria-describedby="pd-desc"
>
  <header class="pd__header">
    <div>
      <h2 id="pd-title">{{ title }}</h2>
      <p id="pd-desc" class="pd__sub" *ngIf="state.step === 'number'">
        <ng-container *ngIf="mode === 'change' && currentMasked">
          Current number: <strong>{{ currentMasked }}</strong>.
          We'll send a code to the new number to confirm it's yours.
        </ng-container>
        <ng-container *ngIf="!(mode === 'change' && currentMasked)">
          Your personal coach messages you on WhatsApp. We'll send a 6-digit code to confirm it's your number.
        </ng-container>
      </p>
      <p id="pd-desc" class="pd__sub" *ngIf="state.step === 'code'">
        We sent a 6-digit code on WhatsApp to <strong>{{ state.maskedNumber }}</strong>.
      </p>
      <p id="pd-desc" class="pd__sub" *ngIf="state.step === 'done'">Your coach can now reach you on WhatsApp.</p>
    </div>
    <button
      type="button"
      class="pd__close"
      aria-label="Close"
      [disabled]="flow?.requestInFlight"
      (click)="cancel()"
      *ngIf="state.step !== 'done'"
    >
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </header>

  <app-whatsapp-verify-flow
    [mode]="mode"
    [source]="source"
    [currentMasked]="currentMasked"
    [legacyE164]="legacyE164"
    [countryIso2]="countryIso2"
    [allowSnooze]="allowSnooze"
    [pending]="pending"
    [showDoneButton]="true"
    (stateChange)="onState($event)"
    (verified)="onVerified($event)"
    (dismissed)="onDismissed()"
    (snoozed)="onSnoozed()"
  ></app-whatsapp-verify-flow>
</div>
